import styled from 'styled-components';

import { colors, media } from '../../../core';

export interface ButtonProps {
  selected: boolean;
  size: 'xsmall' | 'small' | 'medium' | 'large';
  width?: string;
}

const Button = styled.button.attrs(({ type }) => ({
  type: type || 'button',
}))<ButtonProps>`
  -webkit-appearance: none;
  border: 0;
  cursor: default;
  display: inline-flex;
  font-family: ${({ theme }) => theme.fontFamily || 'Quicksand, sans-serif'};
  font-size: 16px;
  font-weight: ${({ theme }) => theme.buttonFontWeight || 600};
  line-height: 20px;
  padding: 0 12px;
  text-decoration: none;
  text-align: center;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
  }

  &:focus {
    outline: 0;
    box-shadow: ${({ theme }) => theme.buttonFocusShadow || `0 0 3px ${colors.primaryHover}`};
  }
  transition: background-color 0.4s ease, color 0.4s ease;

  ${({ selected, disabled, theme }) =>
    selected
      ? `
      background-color: ${colors.white};
      color: ${disabled ? colors.neutral600 : theme.buttonSecondaryColor || colors.primary};

      &:disabled {
        cursor: not-allowed;
      }
      `
      : `
      background-color: transparent;
      color: ${disabled ? colors.neutral600 : colors.rock};

    transition: background-color 0.4s ease, color 0.4s ease, opacity: 0.4s ease;

    &:hover,
    &:focus {
      opacity: 0.9;
      border-color: ${colors.white};
      ${!disabled && `color: ${theme.buttonSecondaryColor || colors.primary}`};
    }

    &:disabled {
      cursor: not-allowed;
    }
  `}
  ${({ theme, size }) =>
    size === 'xsmall' &&
    `
    font-size: 14px;
    line-height: 18px;
    width: 110px;
    min-width: 50%;
    height: ${theme.toggleButtonGroupHeight.xsmall || '24px'};
    border-radius: 4px;
  `}

  ${({ theme, size }) =>
    size === 'small' &&
    `
    font-size: 16px;
    line-height: 20px;
    height: ${theme.toggleButtonGroupHeight.small || '28px'};
    width: 150px;
    min-width: 50%;
    border-radius: 4px;

    ${media.tabletPortrait} {
      font-size: 14px;
    }
  `}

  ${({ theme, size }) =>
    size === 'medium' &&
    `
    font-size: 16px;
    line-height: 20px;
    width: 190px;
    min-width: 50%;
    height: ${theme.toggleButtonGroupHeight.medium || '40px'};
    border-radius: 4px;

    ${media.tabletPortrait} {
      font-size: 14px;
    }
  `}

  ${({ theme, size }) =>
    size === 'large' &&
    `
    font-size: 16px;
    line-height: 20px;
    width: 300px;
    min-width: 50%;
    height: ${theme.toggleButtonGroupHeight.large || '46px'};
    border-radius: 4px;

    ${media.tabletPortrait} {
      font-size: 14px;
    }
  `}

  width: ${({ width }) => width};
`;

export default Button;
